import { useState } from "react";
import { C, G } from "../../styles/theme";
import PBtn from "../common/PBtn";

export default function CallbackWidget() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", phone: "", time: "Morning (9am-12pm)", service: "General Enquiry" });
  const [sent, setSent] = useState(false);
  const fv = k => v => setForm(f => ({ ...f, [k]: v }));
  const submit = () => {
    if (!form.name.trim() || !form.phone.trim()) { alert("Please fill name and phone."); return; }
    setSent(true);
    setTimeout(() => { setSent(false); setOpen(false); setForm({ name: "", phone: "", time: "Morning (9am-12pm)", service: "General Enquiry" }); }, 3000);
  };
  return (
    <div className="callback-btn-container">
      {open && (
        <div className="callback-window">
          <div style={{ background: G.hero, padding: "12px 14px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", alignItems: "center", gap: 8 }}><span style={{ fontSize: 18 }}>📞</span><div><div style={{ color: "#fff", fontWeight: 700, fontSize: 13 }}>Request a Callback</div><div style={{ color: "rgba(255,255,255,.5)", fontSize: 10 }}>We call within 2 hours</div></div></div>
            <button onClick={() => setOpen(false)} style={{ background: "rgba(255,255,255,.14)", border: "none", color: "#fff", width: 24, height: 24, borderRadius: "50%", cursor: "pointer", fontSize: 12, display: "flex", alignItems: "center", justifyContent: "center" }}>x</button>
          </div>
          {sent ? (
            <div style={{ padding: "24px 18px", textAlign: "center" }}>
              <div style={{ fontSize: 32, marginBottom: 8 }}>✅</div>
              <div style={{ fontWeight: 700, color: C.blue, fontSize: 14, marginBottom: 4 }}>Request Received!</div>
              <div style={{ fontSize: 12, color: C.gray }}>We will call you at your preferred time.</div>
            </div>
          ) : (
            <div style={{ padding: "14px 14px 16px" }}>
              {[["name", "Your Name", "text"], ["phone", "Phone Number", "tel"]].map(([k, lb, tp]) => (
                <div key={k} style={{ marginBottom: 9 }}>
                  <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: C.blue, marginBottom: 3 }}>{lb}</label>
                  <input type={tp} value={form[k]} onChange={e => fv(k)(e.target.value)} style={{ width: "100%", padding: "7px 10px", border: `1.5px solid ${C.border}`, borderRadius: 7, fontSize: 13, outline: "none", boxSizing: "border-box" }} />
                </div>
              ))}
              <div style={{ marginBottom: 9 }}>
                <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: C.blue, marginBottom: 3 }}>Preferred Time</label>
                <select value={form.time} onChange={e => fv("time")(e.target.value)} style={{ width: "100%", padding: "7px 10px", border: `1.5px solid ${C.border}`, borderRadius: 7, fontSize: 13, outline: "none", boxSizing: "border-box" }}>
                  {["Morning (9am-12pm)", "Afternoon (12pm-3pm)", "Evening (3pm-6pm)"].map(o => <option key={o}>{o}</option>)}
                </select>
              </div>
              <div style={{ marginBottom: 13 }}>
                <label style={{ display: "block", fontSize: 11, fontWeight: 600, color: C.blue, marginBottom: 3 }}>Service</label>
                <select value={form.service} onChange={e => fv("service")(e.target.value)} style={{ width: "100%", padding: "7px 10px", border: `1.5px solid ${C.border}`, borderRadius: 7, fontSize: 13, outline: "none", boxSizing: "border-box" }}>
                  {["General Enquiry", "Staffing Solutions", "Software Development", "Cyclojet Lab", "Valuation Services"].map(o => <option key={o}>{o}</option>)}
                </select>
              </div>
              <PBtn onClick={submit} full>Request Callback</PBtn>
            </div>
          )}
        </div>
      )}
      <button onClick={() => setOpen(o => !o)} style={{ background: C.blue, color: "#fff", border: "none", borderRadius: 26, padding: "10px 16px", fontWeight: 700, fontSize: 12.5, cursor: "pointer", boxShadow: "0 5px 18px rgba(26,60,110,.38)", display: "flex", alignItems: "center", gap: 6, animation: "wa 3s ease-in-out infinite" }}>
        📞 {open ? "Close" : "Call Me Back"}
      </button>
    </div>
  );
}
